import styled from "styled-components";

const StyledPreview = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 1.5rem 1rem 1rem 1rem;
  min-height: 16.25rem;
`;

export default StyledPreview;



// WEBPACK FOOTER //
// ./src/modules/common/components/form/ui/StyledPreview.js